// Lets a form marked data-single-submit go out only once. A sign-in form rotates the
// CSRF token on success, so a second POST (a double click, or Enter plus the button,
// or Enter after a code auto-submit) carries the old token and lands on a 403 page
// although the sign-in worked.
document.querySelectorAll('form[data-single-submit]').forEach((form) => {
    form.addEventListener('submit', (event) => {
        if (form.dataset.submitted === 'true') {
            event.preventDefault();
            return;
        }
        form.dataset.submitted = 'true';
    });
    // Coming back to the page from the history cache must allow a new attempt.
    window.addEventListener('pageshow', (event) => {
        if (event.persisted) {
            delete form.dataset.submitted;
        }
    });
});
